<template>
    <!--保养首页-->
    <ZhaiHeadPC class="zhai-head"></ZhaiHeadPC>

    <div class="container errong phome-container-box">
        <div class="col-12">
            <ZhaiThreeTuttonsPC></ZhaiThreeTuttonsPC>
        </div>
        <div class="col-12">
            <ZhaiTwoTuttonsPC></ZhaiTwoTuttonsPC>
        </div>

        <!-- 只保留省份筛选 -->
        <div class="row mt-2">
            <div class="col-12 bg-white text-black p-3 tn mb-2 brl d-flex align-items-start justify-content-between">
                <div class="province-label mr-2 daxiao jiacu">省份:</div>

                <div class="province-links d-flex flex-wrap daxiao">
                    <a
                            v-for="province in provinces"
                            :key="province.name"
                            class="text-decoration-none mx-2 text-black"
                            :class="{ active: selectedProvince.name === province.name }"
                            @click.prevent="selectProvince(province)"
                            href="#"
                    >
                        <span>{{ province.name }}</span>
                    </a>
                </div>
            </div>
        </div>

        <!-- 这个隐藏挂载点只负责让子组件请求数据，不占页面空间 -->
        <div class="banner-probe">
            <VipUpgradeDiffBanner
                    ref="vipDiffBanner"
                    :user-id="getUser && getUser.id"
                    :text-prefix="homeUpgradePrefix"
                    @select="handleSelectPermanentUpgrade"
            />
        </div>

        <!-- 只有真正满足补差价条件时，才显示页面里的红条 -->
        <div
                v-if="showUpgradeBanner"
                class="home-diff-banner-wrap"
                @click="triggerBannerClick"
        >
            <div class="home-diff-banner-text">
                {{ fullBannerText }}
            </div>
        </div>
    </div>

    <div class="container errong2 phome-container-box">
        <div class="row card-container">
            <div class="col-md-4 mb-1" v-for="item in items" :key="item.id">
                <MaintenanceCardPC :data="item"></MaintenanceCardPC>
            </div>
        </div>

        <div class="bg-white my-2 p-3 G-Field" style="text-align:center;">
            <nav aria-label="Page navigation example">
                <ul class="pagination">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" href="#" aria-label="Previous" @click.prevent="fetchPage(currentPage - 1)">
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>

                    <li
                            class="page-item"
                            v-for="page in paginationPages"
                            :key="page"
                            :class="{ active: currentPage === page }"
                    >
                        <a class="page-link" href="#" @click.prevent="fetchPage(page)">{{ page }}</a>
                    </li>

                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <a class="page-link" href="#" aria-label="Next" @click.prevent="fetchPage(currentPage + 1)">
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>

    <div class="gongxi2"></div>

    <!-- 升级支付 模态框 -->
    <div class="modal fade" id="upgradeModal" tabindex="-1" aria-labelledby="upgradeModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="upgradeModalLabel">升级支付</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div id="step1">
                        <div>
                            升级VIP目前仅支持支付宝，请确认升级的VIP类型及支付金额是否正确，点击“支付”进行支付。
                        </div>
                        <div class="mt-2">
                            <strong>升级类型：</strong>
                            <span id="uplevel">{{ modalData.type }}</span>
                        </div>
                        <div class="mt-2">
                            <strong>支付金额：</strong>
                            <span id="payamount">{{ modalData.amount }}元</span>
                        </div>
                        <div class="mt-2">
                            <strong>支付方式：</strong>
                            <label class="pay-option1">
                                <input type="radio" name="paytype" value="2040" v-model="payType" id="alipay">
                                {{ alipayOptionText }}
                            </label>
                        </div>

                        <div class="mt-2" style="color:red;">
                            如果支付加载不出来，多试几次就成功了。
                        </div>

                      <div class="text-center mt-5 d-flex justify-content-center gap-4">
                        <button id="startPayBtn" class="btn btn-success" @click="startPayment">支付</button>
                        <button class="btn btn-success" data-bs-dismiss="modal">关闭</button>
                      </div>

                    </div>

                  <div id="step2" style="display:none;">
                    <div id="paymsg" style="text-align: center;font-size: 1rem;font-weight: bold;"></div>
                    <p id="code_msg" style="text-align: center;background: #040404;color: #ffeb00;font-size: 1rem;">
                      如页面出现支付步骤文字说明，请务必看完（尤其是付款注意事项）再进行支付。
                    </p>
                    <p style="text-align: center;font-size: 1rem;color: #000;">
                      请确认支付完成后，再点击“支付完成”
                    </p>
                    <div class="text-center d-flex justify-content-center gap-4">
                      <button id="btnpaysucess" class="btn btn-primary" @click="onManualCheckPayment">支付完成</button>
                      <button class="btn btn-primary" data-bs-dismiss="modal">关闭</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ZhaiFootPC></ZhaiFootPC>
</template>

<script>
    import http from "../utils/http.js";
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import MaintenanceCardPC from "../componentspc/MaintenanceCardPC";
    import ZhaiTwoTuttonsPC from "../componentspc/ZhaiTwoTuttonsPC";
    import ZhaiThreeTuttonsPC from "../componentspc/ZhaiThreeTuttonsPC";
    import VipUpgradeDiffBanner from "../components/VipUpgradeDiffBanner.vue";
    import { mapGetters } from "vuex";
    import { Modal } from "bootstrap";
    import QRCode from "qrcodejs2";

    export default {
        name: "PMaintenance",
        components: {
            ZhaiHeadPC,
            ZhaiFootPC,
            MaintenanceCardPC,
            ZhaiThreeTuttonsPC,
            ZhaiTwoTuttonsPC,
            VipUpgradeDiffBanner
        },
        data() {
            return {
                items: [],
                currentPage: 1,
                totalPages: 1,
                sortBy: "publishTime",
                selectedProvince: { name: "全部" },
                provinces: this.getProvinces(),
                provinceKeyword: "",
                sortKeyword: "发布时间",

                modalData: { type: "", amount: 0 },
                payType: "2040",
                orderId: null,
                manualPolling: false,

                showUpgradeBanner: false,
                bannerSyncTimer: null
            };
        },
        computed: {
            ...mapGetters(["getUser"]),

            paginationPages() {
                const pages = [];
                const startPage = Math.max(1, this.currentPage - 2);
                const endPage = Math.min(this.totalPages, this.currentPage + 2);

                for (let i = startPage; i <= endPage; i++) {
                    pages.push(i);
                }

                if (startPage > 1) {
                    pages.unshift("...");
                    pages.unshift(1);
                }

                if (endPage < this.totalPages) {
                    pages.push("...");
                    pages.push(this.totalPages);
                }

                return pages;
            },

            homeUpgradePrefix() {
                const username = this.getUser?.username || "会员";
                return `尊敬的会员 ${username}：限时补差价 `;
            },

            alipayOptionText() {
                return "支付宝";
            },

            fullBannerText() {
                const banner = this.$refs.vipDiffBanner;
                if (!banner || !banner.upgradeInfo) return "";

                const username = this.getUser?.username || "会员";
                const price = banner.displayPrice(banner.upgradeInfo.upgradePrice);
                const countdown = banner.countdownText || "";

                return `尊敬的会员 ${username}：限时补差价 ${price}元，即可升级为永久会员！${countdown ? `（剩余${countdown}）` : ""}`;
            }
        },
        mounted() {
            this.fetchPage(1);
            this.startBannerSync();
        },
        beforeUnmount() {
            this.stopBannerSync();
        },
        methods: {
            startBannerSync() {
                this.stopBannerSync();

                this.bannerSyncTimer = setInterval(() => {
                    const banner = this.$refs.vipDiffBanner;
                    if (!banner) {
                        this.showUpgradeBanner = false;
                        return;
                    }

                    this.showUpgradeBanner = !!banner.visible;
                }, 500);
            },

            stopBannerSync() {
                if (this.bannerSyncTimer) {
                    clearInterval(this.bannerSyncTimer);
                    this.bannerSyncTimer = null;
                }
            },

            triggerBannerClick() {
                const banner = this.$refs.vipDiffBanner;
                if (banner && typeof banner.handleClick === "function") {
                    banner.handleClick();
                }
            },

            updateTitle() {
                const titleParts = [this.provinceKeyword].filter(Boolean);

                document.title = titleParts.length
                    ? `${titleParts.join(" ")}的全部保养信息 - 御凤楼.it.com`
                    : "御凤楼.it.com";
            },

            fetchPage(page) {
                if (page === "..." || page < 1 || page > this.totalPages) {
                    return;
                }

                const params = new URLSearchParams({
                    pageNum: page || 1,
                    pageSize: 24,
                    sortBy: this.sortBy
                });

                if (this.selectedProvince.name !== "全部") {
                    params.append("source", this.selectedProvince.name);
                }

                const url = `/platform/frontEnd/maintenanceList?${params.toString()}`;

                http.get(url)
                    .then(response => {
                        if (response.data.status === 1) {
                            const data = response.data.data || {};
                            this.items = data.list || [];
                            this.currentPage = data.pageNum || 1;
                            this.totalPages = data.pages || 1;
                        } else {
                            alert(response.data.msg || "请求失败");
                        }
                    })
                    .catch(error => {
                        console.error("请求失败:", error);
                        alert("请求失败，请稍后重试。");
                    });
            },

            selectProvince(province) {
                this.selectedProvince = province;
                this.provinceKeyword = province.name !== "全部" ? province.name : "";
                this.updateTitle();
                this.fetchPage(1);
            },

            handleSelectPermanentUpgrade(payload) {
                this.modalData.type = payload.type;
                this.modalData.amount = payload.amount;
                this.openModal();
            },

            openModal() {
                document.getElementById("step1").style.display = "block";
                document.getElementById("step2").style.display = "none";

                const paymsg = document.getElementById("paymsg");
                if (paymsg) {
                    paymsg.innerHTML = "";
                }

                const modalElement = document.getElementById("upgradeModal");
                const modalInstance = new Modal(modalElement);
                modalInstance.show();
            },

            resetPayButton() {
                const payButton = document.getElementById("startPayBtn");
                if (payButton) {
                    payButton.textContent = "支付";
                    payButton.disabled = false;
                }
            },

            startPayment() {
                const payButton = document.getElementById("startPayBtn");
                if (payButton) {
                    payButton.textContent = "生成中";
                    payButton.disabled = true;
                }

                const { id: userid, username, email } = this.getUser || {};
                if (!userid || !username || !email) {
                    this.resetPayButton();
                    alert("用户信息不完整，请重新登录！");
                    return;
                }

                let requestUrl = "";

                if (this.modalData.type === "限时补差价升级永久会员") {
                    requestUrl = `/platform/frontEndPayment/requestPermanentUpgrade?userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
                } else {
                    requestUrl = `/platform/frontEndPayment/request?name=${encodeURIComponent(this.modalData.type)}&money=${this.modalData.amount}&userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
                }

                http.get(requestUrl)
                    .then(response => {
                        const res = response.data;

                        if (res && res.status === 1 && res.data) {
                            const { payUrl, mchOrderNo } = res.data;

                            if (!payUrl) {
                                this.resetPayButton();
                                alert("支付链接为空，请联系管理员！");
                                return;
                            }

                            this.orderId = mchOrderNo;
                            this.generateQRCode(payUrl);
                        } else {
                            this.resetPayButton();
                            const errorMessage = res?.msg || "未知错误";
                            alert(`支付请求失败：${errorMessage}`);
                        }
                    })
                    .catch(error => {
                        this.resetPayButton();
                        alert(`请求支付失败，请重试。错误详情: ${error.message}`);
                    });
            },

            generateQRCode(payUrl) {
                document.getElementById("paymsg").innerHTML = "请用手机相机扫描下方二维码，从浏览器打开，将自动跳转支付。";

                const qrCodeContainer = document.createElement("div");
                qrCodeContainer.id = "qrcode";
                qrCodeContainer.style.width = "200px";
                qrCodeContainer.style.height = "200px";
                qrCodeContainer.style.marginTop = "20px";

                document.getElementById("paymsg").appendChild(qrCodeContainer);

                new QRCode(qrCodeContainer, {
                    text: payUrl,
                    width: 200,
                    height: 200,
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                  // ✅ 统一改 L（稳定）
                  correctLevel: QRCode.CorrectLevel.L
                });

                document.getElementById("step1").style.display = "none";
                document.getElementById("step2").style.display = "block";

                let remainingTime = 300;

                const countdown = document.createElement("p");
                countdown.id = "countdown";
                countdown.style.textAlign = "center";
                countdown.style.marginTop = "10px";
                countdown.style.fontWeight = "normal";
                countdown.style.color = "rgba(255, 127, 127)";
                countdown.style.fontSize = "0.9rem";
                document.getElementById("paymsg").appendChild(countdown);

                const timer = setInterval(() => {
                    if (remainingTime <= 0) {
                        clearInterval(timer);
                        countdown.innerHTML = "支付已超时，请关闭重新选择支付！";
                        qrCodeContainer.style.filter = "blur(5px)";
                        this.resetPayButton();
                    } else {
                        const minutes = Math.floor(remainingTime / 60);
                        const seconds = remainingTime % 60;
                        countdown.innerHTML = `请在 ${minutes}:${seconds < 10 ? "0" + seconds : seconds} 内完成支付`;
                        remainingTime--;
                    }
                }, 1000);
            },

            onManualCheckPayment() {
                this.manualPolling = true;
                this.checkPaymentStatus();
            },

            checkPaymentStatus() {
                if (!this.orderId) return;

                const statusUrl = `/platform/frontEndPayment/checkPaymentStatus?outTradeNo=${this.orderId}`;
                fetch(statusUrl)
                    .then(response => response.json())
                    .then(data => {
                        if (data.status === 1) {
                            this.handlePaymentSuccessStatus();
                        } else if (this.manualPolling) {
                            alert("未检测到支付完成，请稍后重试");
                        }
                    })
                    .catch(error => {
                        console.error("轮询支付状态异常:", error);
                    });
            },

            handlePaymentSuccessStatus() {
                this.$store.dispatch("checkLoginStatus");

                const banner = this.$refs.vipDiffBanner;
                if (banner && typeof banner.refresh === "function") {
                    banner.refresh();
                }

                this.fetchPage(this.currentPage || 1);
                alert("支付已成功");
            },

            getProvinces() {
                return [
                    { name: "全部" },
                    { name: "北京" },
                    { name: "上海" },
                    { name: "天津" },
                    { name: "重庆" },
                    { name: "河北" },
                    { name: "山西" },
                    { name: "辽宁" },
                    { name: "吉林" },
                    { name: "黑龙江" },
                    { name: "江苏" },
                    { name: "浙江" },
                    { name: "安徽" },
                    { name: "福建" },
                    { name: "江西" },
                    { name: "山东" },
                    { name: "河南" },
                    { name: "湖北" },
                    { name: "湖南" },
                    { name: "广东" },
                    { name: "广西" },
                    { name: "海南" },
                    { name: "四川" },
                    { name: "贵州" },
                    { name: "云南" },
                    { name: "西藏" },
                    { name: "陕西" },
                    { name: "甘肃" },
                    { name: "青海" },
                    { name: "宁夏" },
                    { name: "新疆" },
                    { name: "香港" },
                    { name: "澳门" },
                    { name: "台湾" }
                ];
            }
        }
    };
</script>

<style scoped>
    body {
        font-size: 100%;
    }

    .gongxi2 {
        height: 20px;
    }

    .errong {
        padding-left: 30px;
        padding-right: 30px;
    }

    .phome-container-box {
        margin-left: auto !important;
        margin-right: auto !important;
    }

    .errong2 {
        padding-left: 15px;
        padding-right: 15px;
    }

    .tn {
        clear: both;
    }

    .province-label {
        flex-shrink: 0;
        margin-right: 10px;
    }

    .province-links {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-left: 0;
        flex-grow: 1;
        gap: 0.5rem;
    }

    .daxiao {
        font-size: 0.95rem;
    }

    .active {
        color: #18b371 !important;
    }

    .card-container {
        display: flex;
        flex-wrap: wrap;
        margin-left: -1px;
        margin-right: -1px;
    }

    .col-md-4 {
        padding-left: 2px;
        padding-right: 2px;
    }

    @media (min-width: 768px) {
        .zhai-head {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
        }

        .errong {
            margin-top: 70px;
        }
    }

    .G-Field {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 70px;
    }

    .page-link {
        color: #6c757d;
    }

    .pagination {
        line-height: 1;
        border-color: #dee2e6;
    }

    .active > .page-link,
    .page-link.active {
        background-color: #212429 !important;
        color: white !important;
        border-color: #212429 !important;
    }

    /* 这个隐藏挂载点不占位 */
    .banner-probe {
        position: absolute;
        left: -99999px;
        top: -99999px;
        width: 1px;
        height: 1px;
        overflow: hidden;
        pointer-events: none;
    }

    /* 真正显示在页面上的红条 */
    .home-diff-banner-wrap {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 5px;
      margin-bottom: 5px;
    }

    .home-diff-banner-text {
      display: block;
      width: 100%;
      background: #ffffff;
      color: #ff2b2b;
      padding: 5px 5px;
      border-radius: 0;
      font-size: 1.1rem;
      font-weight: 600;
      line-height: 1.8;
      box-sizing: border-box;
      cursor: pointer;
    }

    #btnpaysucess,
    .modal-body .btn-primary,
    .btn-success {
        background-color: #00c26f !important;
        border: none !important;
    }

    #paymsg {
        color: #00c26f;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    #qrcode {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: filter 0.5s ease;
    }

    #countdown {
        font-size: 0.7rem;
        color: red !important;
        text-align: center;
    }

    .pay-option1 {
        margin-right: 40px;
    }
</style>
